class SegmentNavigation {

    constructor(options = {}) {
        this.linkSelector = options.linkSelector || ".aside__link";
        this.activeClass = options.activeClass || "current";
        this.scroller = options.scroller || undefined;

        this.links = [];
        this.items = [];
        this.triggers = [];

        this.init();
    }

    init() {
        if (!window.ScrollTrigger) {
            console.warn("ScrollTrigger fehlt.");
            return;
        }

        this.links = Array.from(document.querySelectorAll(this.linkSelector));

        if (!this.links.length) return;

        // Links → Targets sammeln
        this.items = this.links
            .map(link => {
                const id = link.dataset.segmentId;
                const target = document.getElementById(id);
                return target ? { link, target } : null;
            })
            .filter(Boolean)
            .sort((a, b) => a.target.offsetTop - b.target.offsetTop);

        this.items.forEach(({ link, target }, idx) => {

            const trigger = ScrollTrigger.create({
                trigger: target,
                scroller: this.scroller,
                start: "top 40%",
                end: "bottom 40%",

                onEnter: () => this.setCurrent(link),
                onEnterBack: () => this.setCurrent(link),

                onLeave: () => link.classList.remove(this.activeClass),

                onLeaveBack: () => {
                    if (idx === 0) this.clearCurrent();
                    else link.classList.remove(this.activeClass);
                }
            });

            this.triggers.push(trigger);
        });
    }

    setCurrent(link) {
        this.links.forEach(l => l.classList.remove(this.activeClass));
        link.classList.add(this.activeClass);
    }

    clearCurrent() {
        this.links.forEach(l => l.classList.remove(this.activeClass));
    }

    refresh() {
        if (window.ScrollTrigger) ScrollTrigger.refresh();
    }

    destroy() {
        this.triggers.forEach(t => t.kill());
        this.triggers = [];
        this.links = [];
        this.items = [];
    }
}